"use client";

import bus from "@/assets/images/bus.webp";
import earth from "@/assets/images/earth.png";
import Image from "next/image";
import { useTranslation } from "@/app/i18n/client";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

interface Props {
  small?: true;
  label?: string;
  className?: string;
}

export default function LoadingSpinnerBlock(props: Props) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "mt-12 flex min-h-60 w-full flex-col items-center justify-center gap-12",
        props.className,
        props.small && "mt-4 min-h-40 gap-4",
      )}
      aria-busy="true"
    >
      <div
        className={cn(
          "motion-safe:world-spin-left relative h-[100px] w-[100px]",
          props.small && "h-[50px] w-[50px]",
        )}
      >
        <Image
          src={earth}
          alt={t("LOADING.IMGALT.EARTH")}
          width={100}
          height={100}
          className="absolute block h-full w-full"
        />
        <div className="absolute h-full w-full motion-safe:animate-spin-bus">
          <Image
            src={bus}
            alt={t("LOADING.IMGALT.BUS")}
            width={60}
            height={60}
            className="h-auto w-[60%] motion-safe:animate-jump-bus"
          />
        </div>
      </div>
      {props.label && <div className="w-full text-center">{props.label}</div>}
    </div>
  );
}
